import { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useLocalization } from '../../contexts/LocalizationContext';
import NavMenu from './NavMenu';
import Header from './Header';
import MessageComponent from '../Common/MessageComponent';

const MainLayout = () => {
  const { getDirection } = useLocalization();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(() => {
    return window.localStorage.getItem('rak-admin-sidebar-collapsed') === 'true';
  });
  const location = useLocation();

  // Close sidebar on every navigation event (location.key changes on every navigation)
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.key]);
  const [message, setMessage] = useState(null);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const toggleSidebar = () => {
    if (window.matchMedia('(max-width: 768px)').matches) {
      toggleMobileMenu();
      return;
    }

    setIsSidebarCollapsed((current) => {
      const next = !current;
      window.localStorage.setItem('rak-admin-sidebar-collapsed', String(next));
      return next;
    });
  };

  return (
    <div className={`admin-layout ${isSidebarCollapsed ? 'sidebar-collapsed' : ''}`} dir={getDirection()}>
      {isMobileMenuOpen && (
        <div className="overlay active" onClick={toggleMobileMenu}></div>
      )}

      <aside className={`sidebar ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
        <NavMenu onLinkClick={() => setIsMobileMenuOpen(false)} isCollapsed={isSidebarCollapsed} />
      </aside>
      
      <div className="main-wrapper">
        <Header onMenuToggle={toggleSidebar} isSidebarCollapsed={isSidebarCollapsed} />
        
        <main className="content-area content-area-full">
          <Outlet />
        </main>
      </div>

      {message && (
        <MessageComponent
          message={message.message}
          title={message.title}
          type={message.type}
          isVisible={true}
          onClose={() => setMessage(null)}
        />
      )}
    </div>
  );
};

export default MainLayout;
